export default {
    HOME: 'https://support.gotennapro.com/s/',
    FREQUENCY_SETS: 'https://support.gotennapro.com/s/article/Portal-Navigation-Frequency-Sets',
}
